module.exports = __webpack_public_path__ + "img/programs.986200ce.svg";